<script lang="ts">
  import { Route } from "svelte-router-spa";

  import Spacer from "@/components/spacer.svelte";
  import Section1 from "./subviews/section1.svelte";
  import Section2 from "./subviews/section2.svelte";
  import Section3 from "./subviews/section3.svelte";
  import Section4 from "./subviews/section4.svelte";
  import Section5 from "./subviews/section5.svelte";

  export let currentRoute;
  export let params = {};
</script>

<Route {currentRoute} {params} />

<Section1 />

<Spacer size="10rem" />

<div id="wrap">
  <Section2 />

  <Spacer size="10vw" />

  <Section3 />

  <Spacer size="10vw" />

  <Section4 />

  <Spacer size="10vw" />

  <Section5 />

  <Spacer size="10vw" />
</div>

<style lang="scss">
  :global(.mainview) {
    :global(h1) {
      font-size: 3.3rem !important;
      font-weight: 800 !important;
    }
    :global(h2) {
      font-size: 1.4rem !important;
      font-weight: 600 !important;
    }
    :global(h3) {
      font-size: 1.2rem;
      font-weight: 600;
    }
    :global(div) {
      font-size: 17px;
    }
  }

  #wrap {
    color: #5c3327;
  }
</style>
